<ng-container *ngFor="let item of data; index as i">
  <ng-container *ngIf="bodyTemplateRef" [ngTemplateOutlet]="bodyTemplateRef" [ngTemplateOutletContext]="{$implicit: item, idx: i}"></ng-container>
</ng-container>
